//#region src/utils/idioma.ts
var Idioma = /* @__PURE__ */ function(Idioma) {
	Idioma["PT_BR"] = "PT_BR";
	Idioma["EN"] = "EN";
	Idioma["ES"] = "ES";
	return Idioma;
}({});
var IdiomaInfo = {
	["PT_BR"]: {
		language: "pt-br",
		icon: "brazil"
	},
	["EN"]: {
		language: "en",
		icon: "united-states"
	},
	["ES"]: {
		language: "es",
		icon: "spain"
	}
};
//#endregion
export { Idioma, IdiomaInfo };
